export class AgencyAddress {
  addressLine1: string;
  primaryMobileNumber: number;
  landmark: string;
  secondaryContactNumber: number;
  state: string;
  primaryEmail: string;
  city: string;
  postal_code: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/agency.address.model.ts